import { render, staticRenderFns } from "./A.vue?vue&type=template&id=2dcd0ccf&"
import script from "./A.vue?vue&type=script&lang=js&"
export * from "./A.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dcd0ccf')) {
      api.createRecord('2dcd0ccf', component.options)
    } else {
      api.reload('2dcd0ccf', component.options)
    }
    module.hot.accept("./A.vue?vue&type=template&id=2dcd0ccf&", function () {
      api.rerender('2dcd0ccf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/pages/configurator/A.vue"
export default component.exports